import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Button, CircularProgress } from "@material-ui/core";
import { showMessage } from "../../state/app/appActions";
import { confirmAuthorization } from "../../main/app-axios";
import { useDispatch } from "react-redux";

const ALLOW_ROLES = ["MANAGER_AUTHORIZATION"];

const useStyles = makeStyles({
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
  contentText: {
    color: "#757575",
    fontSize: "14px",
  },
  textField: {
    marginTop: 15,
  },
  dialogActions: {
    justifyContent: "space-between",
    padding: 15,
  },
  container: {
    padding: 25,
    paddingTop: 0,
  },
});

export default function Authorization({
  action,
  actionText,
  disabled = false,
  cancel,
  cancelText,
  endIcon = null,
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const disabledAction =
    username === "" || password === "" || loadingSubmit || disabled;

  const handleSubmit = async () => {
    try {
      setLoadingSubmit(true);
      const autorization = await confirmAuthorization({
        username: username.includes("@")
          ? username
          : `${username}@americanas.io`,
        password,
      });
      if (autorization.roles.some((role) => ALLOW_ROLES.includes(role))) {
        action({
          nomeAutorizador: autorization.user.no_usuario,
          emailAutorizador: autorization.user.de_email,
        });
      } else {
        dispatch(showMessage("Usuário não autorizado.", "warning"));
      }
    } catch (error) {
      dispatch(
        showMessage(
          error?.response?.data?.message || "Usuário não autorizado.",
          "warning"
        )
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <>
      <div className={classes.container}>
        <p className={classes.contentText}>Informe os dados do autorizador</p>
        <hr className={classes.hr} />
        <TextField
          variant="outlined"
          fullWidth
          label="Login do autorizador *"
          name="login"
          className={classes.textField}
          rows={1}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          variant="outlined"
          fullWidth
          label="Senha do autorizador *"
          name="emailAutorizador"
          className={classes.textField}
          rows={1}
          value={password}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <hr className={classes.hr} />

      <div className={classes.dialogActions}>
        <Button onClick={cancel} variant="outlined">
          {cancelText}
        </Button>
        <Button
          onClick={() => handleSubmit()}
          variant="contained"
          color="secondary"
          disabled={disabledAction}
          style={{ float: "right" }}
          endIcon={endIcon}
        >
          {actionText}
          {loadingSubmit && (
            <CircularProgress
              size={24}
              color="inherit"
              style={{ marginLeft: 10 }}
            />
          )}
        </Button>
      </div>
    </>
  );
}
